import { Fragment, h } from 'preact'
export const IconMore = ({ count, breakpoint, productUrl }) => {
    return (
        <div class="icon icon-more">
            <a href={productUrl}>+{count - breakpoint}</a>
        </div>
    )
}
